import {
  logEvent,
  trackFullStoryEvent
} from '../../../analytics/modules/middleware'
import {trackEvent} from '../../../analytics/modules/actions'
import {Action, Category, Entity, Team} from '../../../analytics/types/Events'

export const handleRecaptchaValidationError = (error, dispatch) => {
  let errorDetail: {message?: string; score?: string} = {}
  try {
    // error.message is like: "PreSignUp failed with error CustomError:{"message":"Low reCaptcha score","score":0.3}."
    errorDetail = JSON.parse(
      error.message.split('CustomError:')[1].slice(0, -1)
    )
  } catch {
    errorDetail = {message: error.message}
  }

  logEvent('PasswordlessCaptchaError', errorDetail)
  trackFullStoryEvent('PasswordlessCaptchaError', errorDetail)

  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.Signup,
      action: Action.Errored,
      payload: {
        score: errorDetail?.score
      },
      team: Team.Retention
    })
  )
}
